(function () {
  var GIFT_HANDLE = 'brosse-doree-gloss-by-k-offerte';
  var MIRROR_HANDLE = 'mirror-72h-anti-frizz-anti-humidity-leave-in';
  var GIFT_VARIANT_ID = 54322650415441;
  var GIFT_IMAGE = 'REPLACED_BASE64_PLACEHOLDER';
  var syncing = false;

  function isFrLang() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('fr') === 0;
  }

  function giftPropertyLabel() {
    return isFrLang() ? 'Offert avec Mirror 72H' : 'Gift with Mirror 72H';
  }

  function giftBadgeLabel() {
    return isFrLang() ? 'Cadeau exclusif offert avec votre commande.' : 'Exclusive free gift with your order.';
  }

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function internalHeaders() {
    return { 'Content-Type': 'application/json', 'X-GBK-Gift-Sync': '1' };
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: internalHeaders(),
      body: JSON.stringify({
        items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _cadeau: giftPropertyLabel() } }]
      })
    });
  }

  function setGiftQuantity(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: internalHeaders(),
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  function refreshUI() {
    if (typeof window.updateCartDrawer === 'function') {
      window.updateCartDrawer();
    }
    if (window.location.pathname.indexOf('/cart') === 0) {
      window.location.reload();
    }
    styleGiftLineItems();
  }

  window.gbkSyncGiftCart = function () {
    if (syncing) return;
    syncing = true;
    getCart().then(function (cart) {
      var mirrorItem = null;
      var giftItem = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].handle === MIRROR_HANDLE) mirrorItem = cart.items[i];
        if (cart.items[i].handle === GIFT_HANDLE) giftItem = cart.items[i];
      }

      if (mirrorItem && !giftItem) {
        addGift().then(function () {
          syncing = false;
          refreshUI();
        }).catch(function () { syncing = false; });
        return;
      }

      if (!mirrorItem && giftItem) {
        setGiftQuantity(giftItem.key, 0).then(function () {
          syncing = false;
          refreshUI();
        }).catch(function () { syncing = false; });
        return;
      }

      if (giftItem && giftItem.quantity !== 1) {
        setGiftQuantity(giftItem.key, 1).then(function () {
          syncing = false;
          refreshUI();
        }).catch(function () { syncing = false; });
        return;
      }

      syncing = false;
      styleGiftLineItems();
    }).catch(function () {
      syncing = false;
    });
  };

  function decorateGiftLi(li) {
    if (!li) return;
    li.classList.add('gbk-gift-line');

    li.querySelectorAll(
      '.close-cart-product, .cart-product-remove-link, .cart-product-remove--toggle, cart-remove-button, .cart-item__quantity, quantity-input, quantity-popover, .qty-container, .quantity-popover-wrapper'
    ).forEach(function (el) {
      el.style.display = 'none';
    });

    var existingBadge = li.querySelector('.gbk-gift-badge');
    var label = giftBadgeLabel();
    if (existingBadge) {
      if (existingBadge.textContent !== label) {
        existingBadge.textContent = label;
      }
    } else {
      var badge = document.createElement('p');
      badge.className = 'gbk-gift-badge';
      badge.textContent = label;
      var detail =
        li.querySelector('.product-detail') ||
        li.querySelector('.card-product-thumb-info') ||
        li.querySelector('.cart-item__details') ||
        li;
      detail.appendChild(badge);
    }
    li.dataset.gbkGiftStyled = 'true';
  }

  function styleGiftLineItems() {
    document.querySelectorAll('[data-variant-id]').forEach(function (li) {
      if (String(li.getAttribute('data-variant-id')) === String(GIFT_VARIANT_ID)) {
        decorateGiftLi(li);
      }
    });
    document.querySelectorAll('[data-quantity-variant-id]').forEach(function (input) {
      if (String(input.getAttribute('data-quantity-variant-id')) === String(GIFT_VARIANT_ID)) {
        decorateGiftLi(input.closest('li'));
      }
    });
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isOwnSyncCall = init && init.headers && init.headers['X-GBK-Gift-Sync'];
    var isCartMutation = /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
    var result = originalFetch.apply(this, arguments);
    if (isCartMutation && !isOwnSyncCall) {
      result.then(function () {
        setTimeout(function () {
          window.gbkSyncGiftCart();
        }, 350);
      });
    }
    return result;
  };

  document.addEventListener('DOMContentLoaded', function () {
    window.gbkSyncGiftCart();
    setTimeout(styleGiftLineItems, 800);
  });

  var observer = new MutationObserver(function () {
    styleGiftLineItems();
  });
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('cart_drawer');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
  });
})();
